// A call belongs to an account, but only its owning connection may render Return.
// Pending media claims also own the call; a disconnected lease may be reclaimed.
export const isMessengerV2CallOwnedElsewhere = (call, currentUserId, localCall = {}) => {
  if (!call || currentUserId == null) return false;
  if (String(localCall.callId) === String(call.id) &&
      ['active', 'connecting', 'reconnecting'].includes(localCall.status)) return false;
  const participant = call.participants?.find(member => String(member.id) === String(currentUserId));
  if (participant) return Boolean(participant.joined_at && !participant.left_at && !participant.disconnected_at);
  return Boolean(call.live_participants?.some(member => String(member.id) === String(currentUserId)));
};

export const createInitialMessengerV2CallState = () => ({
  status: 'idle',
  callId: null,
  connectionId: null,
  rejoining: false,
  lifecycleVersion: null,
  conversationId: null,
  provider: null,
  livekitUrl: null,
  mode: 'voice',
  direction: null,
  presentation: 'hidden',
  returnPath: null,
  peerUserId: null,
  peerName: null,
  startedByUserId: null,
  startedByName: null,
  startedByAvatarUrl: null,
  startedByInitials: null,
  muted: false,
  soundMuted: false,
  soundMutePending: false,
  cameraEnabled: true,
  screenShareStatus: 'idle',
  screenShareError: null,
  videoBackgroundEffect: 'none',
  videoBackgroundEffectPending: false,
  videoBackgroundEffectError: null,
  remoteMuted: false,
  remoteCameraEnabled: true,
  audioOutputDevices: [],
  audioOutputDeviceId: null,
  audioOutputSupported: false,
  localStream: null,
  remoteStream: null,
  participants: [],
  participantHistory: [],
  startedAt: null,
  connectedAt: null,
  endedAt: null,
  error: null,
  pendingOffer: null,
  mediaE2ee: null,
  secureSignalReady: false,
  answerRequested: false,
  expiresAt: null,
});
